import React from "react"
import PropTypes from "prop-types"
import {Route} from "react-router-dom"

import {NestedRoute} from "@irati/utils/history/routing"

import AppContainer from "@irati/ui/src/AppContainer"

import PublicContainer from "../containers/Public/Public"

export const PUBLIC = "PUBLIC"

const Public = ({path}) =>
  <Route
    path={path}
    render={() =>
      <AppContainer>
        <NestedRoute path="/" title="Perkbox" component={PublicContainer} />
      </AppContainer>
    } />


Public.propTypes = {
  path: PropTypes.string.isRequired
}

export default Public
